import { PHOTO } from 'constants/urls';
import { getToken } from './token';

export const getPhotoUrl = id => (
    id ? `/api${PHOTO.stringify({ id })}?token=${getToken()}` : null
);
